import React from 'react';
import Button from '@mui/material/Button';
import { Grid, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import InputForm from '../../commun/input-form';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { ProposalsAssignmentsFormDto } from '../../../services/dtos/assignments.dto';

/**
 * Compsant qui permet de rechercher les compositions
 * @constructor
 * @param props
 */
export default function ProposalsAssignmentsForm(
    props: Readonly<{
        handlerSearch: (e: ProposalsAssignmentsFormDto) => void;
        searching: boolean;
    }>
) {
    //Initialisation des valeurs
    const iniValues: ProposalsAssignmentsFormDto = {
        reference: '',
        codeTBB: '',
        name: '',
        place: '',
    };

    return (
        //Retourne la vue
        <Formik
            initialValues={iniValues}
            onReset={props.handlerSearch}
            onSubmit={props.handlerSearch}
            className="form-intervention"
        >
            {/* Formulaire */}
            <Form>
                <Grid container spacing={2} sx={{ marginTop: '10px' }}>
                    <Grid item xs={12} md={1.5}>
                        {/*champ référence*/}
                        <InputForm id="reference" name="reference" label="Référence" />
                    </Grid>
                    <Grid item xs={12} md={1.5}>
                        {/*champ Code TBB*/}
                        <InputForm id="codeTBB" name="codeTBB" label="Code TBB" />
                    </Grid>
                    <Grid item xs={12} md={1.5}>
                        {/*champ nom*/}
                        <InputForm id="name" name="name" label="Nom" />
                    </Grid>
                    <Grid item xs={12} md={1.5}>
                        {/*champ lieu*/}
                        <InputForm id="place" name="place" label="Lieu" />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={1.5}
                        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        {/*Gestion des boutons*/}
                        <Typography variant={'button'} className={'buttons-form'}>
                            <Button variant="neutral" type="reset">
                                <ClearIcon />
                            </Button>
                            {/*Bouton valider, désactivé durant le traitement du formulaire*/}
                            <Button
                                data-testid={'search-proposals-assignments'}
                                type="submit"
                                variant="contained"
                                sx={{ marginLeft: '10px' }}
                                disabled={props.searching}
                            >
                                <SearchIcon />
                            </Button>
                        </Typography>
                    </Grid>
                </Grid>
            </Form>
        </Formik>
    );
}
